// extracted by mini-css-extract-plugin
module.exports = {"standardTabButton":"standardTabButton__BgQ84","standardTabPanel":"standardTabPanel__yX2Pa","standardTabSlider":"standardTabSlider__e0WSz"};